import React, { FC, useState } from 'react';
import { Paper } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import EmailTemplate from './EmailTemplate/EmailTemplate';
import SMSTemplate from './SMSTemplate/SMSTemplate';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Paper>{children}</Paper>}
    </div>
  );
}

const TemplatesPage: FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} data-testid="templates-page">
        <Tab label="Email" />
        <Tab label="SMS" />
      </Tabs>
      <TabPanel data-testid="email-templates-page" value={tabValue} index={0}>
        <EmailTemplate />
      </TabPanel>
      <TabPanel data-testid="sms-templates-page" value={tabValue} index={1}>
        <SMSTemplate />
      </TabPanel>
    </>
  );
};

export default TemplatesPage;
